import script from "./BulkEditModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulkEditModal.vue?vue&type=script&setup=true&lang=ts"

import "./BulkEditModal.vue?vue&type=style&index=0&id=c31c4182&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c31c4182"]])

export default __exports__